// Mon compte : le prénom et le nom que chacun se donne, montrés partout comme auteur.
export default {
  titre: 'Mon compte',
  sousTitre: 'Votre nom dans Orion : il signe ce que vous créez',
  prenom: 'Prénom',
  nom: 'Nom',
  adresse: 'Adresse e-mail',
  vous: 'Vous apparaissez comme',
  enregistrer: 'Enregistrer',
  enregistre: 'Enregistré.',
  erreur: 'Le nom n’a pas pu être enregistré.',
  langue: 'Langue',
}
